import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlXCellObject from './dhtmlXCellObject';
import dhtmlXLayoutObject from './dhtmlXLayoutObject';

class dhtmlXLayoutCell extends dhtmlXCellObject {
    constructor(g, e) {
        super();
        // @ts-ignore
        dhtmlXCellObject.apply(this, [g, "_layout"]);
        var c = this;
        this.layout = e;
        this.conf.skin = this.layout.conf.skin;
        this.conf.mode = this.layout.conf.mode;
        this.conf.collapsed = false;
        this.conf.fixed = {w: false, h: false};
        this.conf.docked = true;
        if (this.conf.skin == "material") {
            this.conf.min_width = 42;
            this.conf.min_height = 26;
        } else {
            this.conf.min_width = 26;
            this.conf.min_height = 26;
        }
        this.attachEvent("_onCellUnload", function () {
            // @ts-ignore
            this.cell.childNodes[this.conf.idx.hdr].ondblclick = null;
            // @ts-ignore
            if (this.conf.mode != "c") {
                // @ts-ignore
                this.cell.childNodes[this.conf.idx.hdr].lastChild.onclick = null;
            }
            // @ts-ignore
            this._unloadDocking();
            // @ts-ignore
            this.layout = null;
            c = null;
        });
        this._hdrInit();
        this.cell.childNodes[this.conf.idx.hdr].ondblclick = function () {
            var h = c.layout._getMainInst();
            h._callMainEvent("onDblClick", [c.conf.name]);
            h = null;
        };
        this.attachEvent("_onContentLoaded", function () {
            // @ts-ignore
            var h = this.layout._getMainInst();
            // @ts-ignore
            h._callMainEvent("onContentLoaded", [this.conf.name]);
            h = null;
        });
        if (this.conf.mode != "c") {
            var a = document.createElement("DIV");
            a.className =
                "dhxlayout_arrow dhxlayout_arrow_" + this.conf.mode + this._idd;
            this.cell.childNodes[this.conf.idx.hdr].appendChild(a);
            a.onclick = function (h) {
                if (c.conf.collapsed) {
                    c.expand();
                } else {
                    c.collapse();
                }
            };
            a = null;
        }
        this.attachEvent("_onBeforeContentAttach", function (h) {
            if (h == "tabbar" || h == "layout" || h == "acc") {
                // @ts-ignore
                this._hideBorders();
            }
            if (
                h == "sidebar" &&
                // @ts-ignore
                this.conf.skin != "dhx_skyblue" &&
                // @ts-ignore
                this.conf.skin != "dhx_terrace"
            ) {
                // @ts-ignore
                this._hideBorders();
                // @ts-ignore
                this.showHeader();
            }
        });

        this._initDocking();
        return this;
    }
}
dhtmlXLayoutCell.prototype.getId = function () {
    return this.conf.name;
};
dhtmlXLayoutCell.prototype._initDocking = function () {
    var a = this;
    var e = null;
    this.dock = function () {
        e = this.layout._getMainInst();
        if (e.dhxWins == null || this.conf.docked) {
            e = null;
            return;
        }
        var c = e.dhxWins.window(this.conf.name);
        c.close();
        this._attachFromCell(c);
        this.conf.docked = true;
        if (!this.conf.dock_collapsed) {
            this.expand();
        }
        e._callMainEvent("onDock", [this.conf.name]);
        e = c = null;
    };
    this.undock = function (c, n, l, m) {
        var g = this.layout._getMainInst();
        if (g.dhxWins == null || this.conf.docked == false) {
            g = null;
            return;
        }
        this.conf.dock_collapsed = this.conf.collapsed;
        if (!this.conf.collapsed) {
            this.collapse();
        }
        if (g.dhxWins.window(this.conf.name) != null) {
            e = g.dhxWins.window(this.conf.name);
            e.show();
        }
        else {
            if (c == null) {
                c = 20;
            }
            if (n == null) {
                n = 20;
            }
            if (l == null) {
                l = 320;
            }
            if (m == null) {
                m = 200;
            }
            e = g.dhxWins.createWindow(this.conf.name, c, n, l, m);
            e.button("close").hide();
            e.addUserButton("dock", 99, "Dock");
            e.button("dock").show();
            e.button("dock").attachEvent("onClick", this._doOnDockClick);
            e.setText(this.getText());
            e.attachEvent("onClose", this._doOnDockWinClose);
        }
        this.conf.docked = false;
        e._attachFromCell(this);
        g._callMainEvent("onUnDock", [this.conf.name]);
        g = e = null;
    };
    this._doOnDockClick = function () {
        a.dock();
    };
    this._doOnDockWinClose = function (c) {
        c.hide();
        return false;
    };
    this._unloadDocking = function () {
        a = null;
    };
};
dhtmlXLayoutCell.prototype._hdrInit = function () {
    var c = "";
    if (dhx4.isIE) {
        if (navigator.userAgent.indexOf("MSIE 9.0") != -1) {
            c = " dhx_cell_hdr_text_ie9";
        }
        else {
            if (dhx4.isIE8) {
                c = " dhx_cell_hdr_text_ie8";
            }
            else {
                if (dhx4.isIE7) {
                    c = " dhx_cell_hdr_text_ie7";
                }
                else {
                    if (dhx4.isIE6) {
                        c = " dhx_cell_hdr_text_ie6";
                    }
                }
            }
        }
    }
    else {
        if (dhx4.isChrome || dhx4.isKHTML) {
            c = " dhx_cell_hdr_text_chrome";
        }
    }
    var a = document.createElement("DIV");
    a.className = "dhx_cell_hdr";
    a.innerHTML = "<div class='dhx_cell_hdr_text" + c + "'></div>";
    this.cell.insertBefore(a, this.cell.childNodes[this.conf.idx.cont]);
    a = null;
    this.conf.ofs_nodes.t._getHdrHeight = "func";
    this.conf.hdr = { visible: true };
    this.conf.idx_data.hdr = "dhx_cell_hdr";
    this._updateIdx();
    this.attachEvent("_onSetSize", this._hdrOnSetSize);
    this.attachEvent("_onBorderChange", this._hdrOnBorderChange);
    this.attachEvent("_onViewSave", this._hdrOnViewSave);
    this.attachEvent("_onViewRestore", this._hdrOnViewRestore);
};
dhtmlXLayoutCell.prototype.showHeader = function (a) {
    if (this.conf.hdr.visible || this.conf.collapsed) {
        return;
    }
    if (this.conf.hdr.w_saved > this._getAvailWidth() ||
        this.conf.hdr.h_saved > this._getAvailHeight()) {
        return;
    }
    this.conf.hdr.w_saved = this.conf.hdr.h_saved = null;
    this.conf.hdr.visible = true;
    this.cell.childNodes[this.conf.idx.hdr].className = "dhx_cell_hdr";
    if (a !== true) {
        this._adjustCont(this._idd);
    }
};
dhtmlXLayoutCell.prototype.hideHeader = function (a) {
    if (!this.conf.hdr.visible || this.conf.collapsed) {
        return;
    }
    this.conf.hdr.w_saved = this._getMinWidth(this._idd);
    this.conf.hdr.h_saved = this._getMinHeight(this._idd);
    this.conf.hdr.visible = false;
    this.cell.childNodes[this.conf.idx.hdr].className =
        "dhx_cell_hdr dhx_cell_hdr_hidden";
    this._hdrUpdBorder();
    this._mtbUpdBorder();
    if (a !== true) {
        this._adjustCont(this._idd);
    }
};
dhtmlXLayoutCell.prototype.isHeaderVisible = function () {
    return this.conf.hdr.visible == true;
};
dhtmlXLayoutCell.prototype.showArrow = function () {
    this.cell.childNodes[this.conf.idx.hdr].childNodes[1].style.display = "";
};
dhtmlXLayoutCell.prototype.hideArrow = function () {
    this.cell.childNodes[this.conf.idx.hdr].childNodes[1].style.display = "none";
};
dhtmlXLayoutCell.prototype.isArrowVisible = function () {
    return (this.cell.childNodes[this.conf.idx.hdr].childNodes[1].style.display == "");
};
dhtmlXLayoutCell.prototype.setText = function (a) {
    this.conf.hdr.text = a;
    this._hdrUpdText();
};
dhtmlXLayoutCell.prototype.getText = function () {
    return this.conf.hdr.text;
};
dhtmlXLayoutCell.prototype.setCollapsedText = function (a) {
    this.conf.hdr.text_collapsed = a;
    this._hdrUpdText();
};
dhtmlXLayoutCell.prototype.getCollapsedText = function () {
    return this.conf.hdr.text_collapsed != null
        ? this.conf.hdr.text_collapsed
        : this.conf.hdr.text;
};
dhtmlXLayoutCell.prototype._hdrUpdText = function () {
    var a = this.conf.collapsed == true && this.conf.hdr.text_collapsed != null
        ? this.conf.hdr.text_collapsed
        : this.conf.hdr.text;
    this.cell.childNodes[this.conf.idx.hdr].firstChild.innerHTML =
        "<span>" + a + "</span>";
};
dhtmlXLayoutCell.prototype._hdrUpdBorder = function () {
    if (this.conf.borders == true) {
        this.cell.childNodes[this.conf.idx.hdr].className =
            "dhx_cell_hdr" + (this.conf.hdr.visible ? "" : " dhx_cell_hdr_hidden");
    }
    else {
        if (!this.conf.hdr.visible) {
            this.cell.childNodes[this.conf.idx.hdr].className =
                "dhx_cell_hdr dhx_cell_hdr_hidden_no_borders";
        }
    }
};
dhtmlXLayoutCell.prototype._hdrOnSetSize = function () {
    if (this.conf.collapsed && this.conf.mode == "v") {
        this._fitHdr();
    }
};
dhtmlXLayoutCell.prototype._hdrOnBorderChange = function () {
    this.hideHeader(true);
    this._hdrUpdBorder();
};
dhtmlXLayoutCell.prototype._hdrOnViewSave = function (a) {
    this.views[a].hdr_vis = this.conf.hdr.visible;
};
dhtmlXLayoutCell.prototype._hdrOnViewRestore = function (a) {
    if (this.conf.hdr.visible != this.views[a].hdr_vis) {
        this[this.views[a].hdr_vis ? "showHeader" : "hideHeader"](true);
    }
    this.views[a].hdr_vis = null;
    delete this.views[a].hdr_vis;
};
dhtmlXLayoutCell.prototype._getHdrHeight = function (a) {
    if (this.conf.collapsed && this.conf.mode == "v" && a !== true) {
        return 27;
    }
    return this.cell.childNodes[this.conf.idx.hdr].offsetHeight;
};
dhtmlXLayoutCell.prototype._fitHdr = function () {
    var c = this.cell.childNodes[this.conf.idx.hdr];
    if (this.conf.collapsed == true) {
        if (typeof dhtmlXLayoutObject.prototype._confGlob.hdrColH == "undefined") {
            c.style.height = this.cell.offsetHeight + "px";
            dhtmlXLayoutObject.prototype._confGlob.hdrColH =
                parseInt(c.style.height) - this._getHdrHeight(true);
        }
        var a = this.cell.offsetHeight + dhtmlXLayoutObject.prototype._confGlob.hdrColH;
        c.style.height = a + "px";
        c.firstChild.style.width = a - 39 + "px";
    }
    else {
        c.firstChild.style.width = c.style.height = null;
    }
    c = null;
};
dhtmlXLayoutCell.prototype.expand = function (m) {
    if (!this.conf.collapsed) {
        return true;
    }
    var e = this.layout;
    var g = null;
    var c = null;
    if (this.conf.mode == "v") {
        var l = m
            ? e.conf.hh
            : e.cdata[e.conf.nextCell[this._idd]]._getMinWidth(this._idd);
        g = e.cont.offsetWidth - e.conf.sw;
        if (l + this.conf.size.w_avl > g) {
            e = null;
            return false;
        }
    }
    else {
        var h = m
            ? e.conf.hh
            : e.cdata[e.conf.nextCell[this._idd]]._getMinHeight(this._idd) +
                e.cdata[e.conf.nextCell[this._idd]]._getHdrHeight();
        c = e.cont.offsetHeight - e.conf.sw;
        if (h + this.conf.size.h_avl > c) {
            e = null;
            return false;
        }
    }
    if (this.conf.docked == false) {
        this.dock();
        return;
    }
    if (this.conf.hdr.visible == false) {
        this.cell.childNodes[this.conf.idx.hdr].className =
            "dhx_cell_hdr dhx_cell_hdr_hidden";
        this._hdrUpdBorder();
    }
    this.cell.className = String(this.cell.className).replace(/\s{0,}dhxlayout_collapsed_[hv]/gi, "");
    this.conf.collapsed = false;
    if (this.conf.mode == "v") {
        this.conf.size.w = Math.min(g - l, this.conf.size.w_saved);
        this.conf.size.w_saved = this.conf.size.w_avl = null;
    }
    else {
        this.conf.size.h = Math.min(c - h, this.conf.size.h_saved);
        this.conf.size.h_saved = this.conf.size.h_avl = null;
    }
    if (this.conf.mode == "v") {
        this._fitHdr();
    }
    e.setSizes(e.conf.nextCell[this._idd], e.conf.nextCell[this._idd], m == true, "expand");
    e.sep._blockSep();
    e = null;
    this._hdrUpdText();
    var a = this.layout._getMainInst();
    a._callMainEvent("onExpand", [this.conf.name]);
    a = null;
    return true;
};
dhtmlXLayoutCell.prototype.collapse = function () {
    if (this.conf.collapsed) {
        return false;
    }
    var c = this.layout;
    if (c.cdata[c.conf.nextCell[this._idd]].expand(true) == false) {
        return false;
    }
    if (this.conf.mode == "v") {
        this.conf.size.w_saved = this.conf.size.w;
        this.conf.size.w_avl = this._getMinWidth(this._idd);
    }
    else {
        this.conf.size.h_saved = this.conf.size.h;
        this.conf.size.h_avl = this._getMinHeight(this._idd) + this._getHdrHeight();
    }
    if (this.conf.hdr.visible == false) {
        this.cell.childNodes[this.conf.idx.hdr].className = "dhx_cell_hdr";
    }
    this.cell.className += " dhxlayout_collapsed_" + this.conf.mode;
    this.conf.collapsed = true;
    if (this.conf.mode == "v") {
        this.conf.size.w = c.conf.hh;
    }
    else {
        this.conf.size.h = this._getHdrHeight();
    }
    c.setSizes(c.conf.nextCell[this._idd], c.conf.nextCell[this._idd], false, "collapse");
    c.sep._blockSep();
    c = null;
    this._hdrUpdText();
    var a = this.layout._getMainInst();
    a._callMainEvent("onCollapse", [this.conf.name]);
    a = null;
    return true;
};
dhtmlXLayoutCell.prototype.isCollapsed = function () {
    return this.conf.collapsed == true;
};
dhtmlXLayoutCell.prototype.setMinWidth = function (a) {
    this.conf.min_width = parseInt(a) || 0;
};
dhtmlXLayoutCell.prototype.setMinHeight = function (a) {
    this.conf.min_height = parseInt(a) || 0;
};
dhtmlXLayoutCell.prototype._getMinWidth = function (c) {
    if (this.dataType == "layout" && this.dataObj != null) {
        if (this.layout._getMainInst() != this.dataObj._getMainInst()) {
            return this.dataObj._getAvailWidth();
        }
        if (this.dataObj.conf.pattern == "1C") {
            return Math.max(this.conf.min_width, this.dataObj.cdata.a._getMinWidth(c));
        }
        else {
            if (this.dataObj.conf.mode == "v") {
                var a = c || this._idd;
                if (this.dataObj.cdata[a].conf.collapsed) {
                    a = this.dataObj.conf.nextCell[a];
                }
                return Math.max(this.conf.min_width, this.dataObj.cdata[a]._getMinWidth(c) +
                    this.dataObj.cdata[this.dataObj.conf.nextCell[a]]._getWidth() +
                    this.dataObj.conf.sw);
            }
            else {
                return Math.max(this.conf.min_width, this.dataObj.cdata.a._getMinWidth(c), this.dataObj.cdata.b._getMinWidth(c));
            }
        }
    }
    return Math.max(this.conf.min_width, 1);
};
dhtmlXLayoutCell.prototype._getMinHeight = function (e) {
    var c = 0;
    if (this.conf.idx.menu != null) {
        c += this.cell.childNodes[this.conf.idx.menu].offsetHeight;
    }
    if (this.dataType == "layout" && this.dataObj != null) {
        if (this.layout._getMainInst() != this.dataObj._getMainInst()) {
            return this.dataObj._getAvailHeight();
        }
        if (this.dataObj.conf.pattern == "1C") {
            return Math.max(this.conf.min_height, this.dataObj.cdata.a._getMinHeight(e));
        }
        else {
            if (this.dataObj.conf.mode == "h") {
                var a = e;
                if (this.dataObj.cdata[a].conf.collapsed) {
                    a = this.dataObj.conf.nextCell[a];
                }
                return Math.max(this.conf.min_height, this.dataObj.cdata[a]._getMinHeight(e) +
                    this.dataObj.cdata[a]._getHdrHeight() +
                    this.dataObj.cdata[this.dataObj.conf.nextCell[a]]._getHeight() +
                    this.dataObj.conf.sw);
            }
            else {
                return Math.max(this.conf.min_height, this.dataObj.cdata.a._getMinHeight(e) +
                    this.dataObj.cdata.a._getHdrHeight(), this.dataObj.cdata.b._getMinHeight(e) +
                    this.dataObj.cdata.b._getHdrHeight());
            }
        }
    }
    return Math.max(this.conf.min_height, c);
};
dhtmlXLayoutCell.prototype._getAvailWidth = function (e) {
    if (this.dataType == "layout" && this.dataObj != null) {
        if (this.dataObj.conf.pattern == "1C") {
            return this.dataObj.cdata.a._getAvailWidth(e);
        }
        else {
            if (this.dataObj.conf.mode == "v") {
                var a = this.dataObj.cdata.a.conf.collapsed == true;
                var c = this.dataObj.cdata.b.conf.collapsed == true;
                if (e == "a") {
                    return this.dataObj.cdata[c ? "a" : "b"]._getAvailWidth(e);
                }
                else {
                    return this.dataObj.cdata[a ? "b" : "a"]._getAvailWidth(e);
                }
            }
            else {
                return Math.min(this.dataObj.cdata.a._getAvailWidth(e), this.dataObj.cdata.b._getAvailWidth(e));
            }
        }
    }
    return this.cell.offsetWidth - this._getMinWidth();
};
dhtmlXLayoutCell.prototype._getAvailHeight = function (g) {
    if (this.dataType == "layout" && this.dataObj != null) {
        if (this.dataObj.conf.pattern == "1C") {
            return this.dataObj.cdata.a._getAvailHeight(g);
        }
        else {
            if (this.dataObj.conf.mode == "h") {
                var c = this.dataObj.cdata.a.conf.collapsed == true;
                var e = this.dataObj.cdata.b.conf.collapsed == true;
                if (g == "a") {
                    return this.dataObj.cdata[e ? "a" : "b"]._getAvailHeight(g);
                }
                else {
                    return this.dataObj.cdata[c ? "b" : "a"]._getAvailHeight(g);
                }
            }
            else {
                return Math.min(this.dataObj.cdata.a._getAvailHeight(g), this.dataObj.cdata.b._getAvailHeight(g));
            }
        }
    }
    var a = this._getHdrHeight();
    if (this.conf.mode == "v" && this.conf.collapsed) {
        a = this.conf.hh;
    }
    return this.cell.offsetHeight - a - this._getMinHeight();
};
dhtmlXLayoutCell.prototype.setWidth = function (g) {
    var h = null, l = null;
    if (this.conf.mode == "v") {
        if (this.conf.collapsed) {
            return;
        }
        h = this.layout;
        l = h.cdata[h.conf.nextCell[this._idd]];
        if (l.conf.collapsed) {
            g = g + h.conf.sw + l._getWidth();
            m = h = l = null;
            return;
        }
        var e = this._getMinWidth(this._idd);
        var n = h.cont.offsetWidth - l._getMinWidth(this._idd) - h.conf.sw;
        g = Math.max(e, Math.min(g, n));
        this.conf.size.w = g;
        h.setSizes(l._idd, l._idd);
        h = l = null;
    }
    else {
        if (this.layout == null || this.layout.parentLayout == null) {
            return;
        }
        var m = this.layout.parentLayout;
        h = this.layout;
        l = h.cdata[h.conf.nextCell[this._idd]];
        for (var c in m.cdata) {
            if (m.cdata[c].dataObj == h) {
                m.cdata[c].setWidth(g);
            }
        }
        m = h = null;
    }
};
dhtmlXLayoutCell.prototype.setHeight = function (n) {
    if (this.conf.mode == "h") {
        if (this.conf.collapsed) {
            return;
        }
        var g = this.layout;
        var m = g.cdata[g.conf.nextCell[this._idd]];
        if (m.conf.collapsed) {
            n = n + g.conf.sw + m._getHeight();
            var o = this.layout != null && this.layout.parentLayout != null
                ? this.layout.parentLayout
                : null;
            if (o != null) {
                for (var c in o.cdata) {
                    if (o.cdata[c].dataObj == g) {
                        o.cdata[c].setHeight(n);
                    }
                }
            }
            o = g = m = null;
            return;
        }
        var l = this._getMinHeight(this._idd) + this._getHdrHeight();
        var e = g.cont.offsetHeight -
            m._getMinHeight(this._idd) -
            m._getHdrHeight() -
            g.conf.sw;
        n = Math.max(l, Math.min(n, e));
        this.conf.size.h = n;
        g.setSizes(m._idd, m._idd);
        g = m = null;
    }
    else {
        if (this.layout == null || this.layout.parentLayout == null) {
            return;
        }
        o = this.layout.parentLayout;
        g = this.layout;
        m = g.cdata[g.conf.nextCell[this._idd]];
        for (var c_1 in o.cdata) {
            if (o.cdata[c_1].dataObj == g) {
                o.cdata[c_1].setHeight(n);
            }
        }
        o = g = null;
    }
};
dhtmlXLayoutCell.prototype.getWidth = function () {
    return this.conf.size.w;
};
dhtmlXLayoutCell.prototype.getHeight = function () {
    return this.conf.size.h;
};
dhtmlXLayoutCell.prototype.fixSize = function (c, g) {
    this.conf.fixed.w = dhx4.s2b(c);
    this.conf.fixed.h = dhx4.s2b(g);
    var a = this.layout._getMainInst();
    var e = {};
    a.forEachItem(function (h) {
        if (h.conf.fsize != null) {
            var o = h.getId();
            var n = { h: h.conf.fixed.w == true, v: h.conf.fixed.h == true };
            for (var l in n) {
                if (n[l] == true && h.conf.fsize[l] != null) {
                    if (!(h.conf.fsize[l] instanceof Array)) {
                        h.conf.fsize[l] = [h.conf.fsize[l]];
                    }
                    for (var m = 0; m < h.conf.fsize[l].length; m++) {
                        e[h.conf.fsize[l][m]] = true;
                    }
                }
            }
        }
        h = null;
    });
    a._forEachSep(function (h) {
        h._lockSep(e[h.conf.idx] == true);
        h = null;
    });
    a = null;
};

export default dhtmlXLayoutCell;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXLayoutObject/dhtmlXLayoutCell.js